"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _designTokens = require("@decisiv/design-tokens");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TextArea = _styledComponents.default.textarea.withConfig({
  displayName: "TextArea",
  componentId: "sc-19p1w4z-0"
})(["font-family:", ";font-size:", ";font-weight:", ";overflow:auto;background-color:inherit;border:transparent;display:block;line-height:140%;margin:0 2px 2px 0;padding:1px 8px 4px 1px;resize:vertical;width:100%;&:active,&:focus{outline:none;}&:required{box-shadow:none;}"], _designTokens.typography.typeface.default, (0, _rem.default)(_designTokens.typography.size.alias.default), _designTokens.typography.weight.alias.default);

var _default = TextArea;
exports.default = _default;